<template>
  <div id="add-new-order-modal">
    <v-layout row justify-center>
      <v-dialog v-model="resetPasswordModal" persistent max-width="800px">
        <v-card>
          <form action="" @submit.prevent="submitForm()">
            <v-card-title>
              <v-flex xs11 sm11 md11><span class="headline">{{ $t('user.resetPasswordTooltip') }}</span></v-flex>
              <v-flex xs1 sm1 md1>
                <v-btn flat @click="closeResetPasswordModal(), $validator.reset()" class="close"
                  ><span aria-hidden="true">
              <i class="material-icons" style="font-size: 24px;vertical-align: middle;">close</i>
            </span></v-btn
                >
              </v-flex>
            </v-card-title>
            <v-card-text>
              <v-alert type="success" :value="checkAlert">
                {{ $t('user.resetPasswordSuccessfully') }}
              </v-alert>
              <v-alert type="error" :value="errorAlert">
                {{ $t('user.confirmPasswordNotMatch') }}
              </v-alert>
              <v-container grid-list-md>
                <v-layout wrap>
                  <v-flex xs12 sm10 md4>
                    <v-text-field
                      style="width: 90%"
                      :append-icon="e2 ? 'visibility' : 'visibility_off'"
                      :append-icon-cb="() => (e2 = !e2)"
                      :type="e2 ? 'password' : 'text'"
                      :label="$t('user.newPassword') + '*'"
                      v-model="resetPasswordData.new_password"
                      :error-messages="errors.collect('new_password')"
                      v-validate="'required|min:6'"
                      data-vv-name="new_password"
                    >
                    </v-text-field>
                  </v-flex>

                  <v-flex xs12 sm10 md4>
                    <v-text-field
                      style="width: 90%"
                      :append-icon="e1 ? 'visibility' : 'visibility_off'"
                      :append-icon-cb="() => (e1 = !e1)"
                      :type="e1 ? 'password' : 'text'"
                      :label="$t('user.confirmPassword') + '*'"
                      v-model="resetPasswordData.confirm_password"
                      :error-messages="errors.collect('confirm_password')"
                      v-validate="'required|min:6'"
                      data-vv-name="confirm_password"
                    >
                    </v-text-field>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                style="height:auto"
                @click="closeResetPasswordModal(), $validator.reset()"
                outline
                color="normal"
                >{{ $t('common.cancel') }}</v-btn
              >
              <v-btn type="submit" style="height:auto" class="rtl-mr-3pct" outline color="success"
                >{{ $t('common.reset') }}</v-btn
              >
            </v-card-actions>
          </form>
        </v-card>
      </v-dialog>
    </v-layout>
  </div>
</template>
<script>
export default {
  props: [
    'resetPasswordModal',
    'closeResetPasswordModal',
    'checkAlert',
    'resetPasswordData',
    'resetPassword',
    'customers'
  ],

  data() {
    return {
      errorAlert: false,
      e1: true,
      e2: true
    }
  },

  methods: {
    submitForm() {
      this.$validator.validateAll().then(res => {
        if (res) {
          if (
            this.resetPasswordData.new_password.trim() ===
            this.resetPasswordData.confirm_password.trim()
          ) {
            this.errorAlert = false
            this.resetPassword()
          } else {
            this.errorAlert = true
          }
        }
      })
    }
  }
}
</script>

<style>
.overlay--active:before {
  opacity: 50 !important;
  background: rgba(0, 0, 0, 0.5) !important;
}
</style>



// WEBPACK FOOTER //
// src/components/user/resetPassword.vue